var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "common-form-inline page-main no-shadow" },
    [
      _c(
        "a-form-model",
        {
          attrs: {
            model: _vm.pageData,
            "label-col": { span: 10 },
            "wrapper-col": { span: 7 }
          }
        },
        [
          _c(
            "a-form-model-item",
            { attrs: { label: "企业名称", prop: "cstNm" } },
            [
              _c("a-input", {
                attrs: { disabled: "" },
                model: {
                  value: _vm.pageData.cstNm,
                  callback: function($$v) {
                    _vm.$set(_vm.pageData, "cstNm", $$v)
                  },
                  expression: "pageData.cstNm"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-form-model-item",
            { attrs: { label: "社会信用代码", prop: "orgCode" } },
            [
              _c("a-input", {
                attrs: { disabled: "" },
                model: {
                  value: _vm.pageData.orgCode,
                  callback: function($$v) {
                    _vm.$set(_vm.pageData, "orgCode", $$v)
                  },
                  expression: "pageData.orgCode"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-form-model-item",
            { attrs: { label: "收款账户", prop: "accountNo" } },
            [
              _c("a-input", {
                attrs: { disabled: "" },
                model: {
                  value: _vm.pageData.accountNo,
                  callback: function($$v) {
                    _vm.$set(_vm.pageData, "accountNo", $$v)
                  },
                  expression: "pageData.accountNo"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-form-model-item",
            { attrs: { label: "账户户名", prop: "accountName" } },
            [
              _c("a-input", {
                attrs: { disabled: "" },
                model: {
                  value: _vm.pageData.accountName,
                  callback: function($$v) {
                    _vm.$set(_vm.pageData, "accountName", $$v)
                  },
                  expression: "pageData.accountName"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-form-model-item",
            { attrs: { label: "开户银行", prop: "accountBank" } },
            [
              _c("a-input", {
                attrs: { disabled: "" },
                model: {
                  value: _vm.pageData.accountBank,
                  callback: function($$v) {
                    _vm.$set(_vm.pageData, "accountBank", $$v)
                  },
                  expression: "pageData.accountBank"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-form-model-item",
            { attrs: { label: "大额行号", prop: "largeBankNo" } },
            [
              _c("a-input", {
                attrs: { disabled: "" },
                model: {
                  value: _vm.pageData.largeBankNo,
                  callback: function($$v) {
                    _vm.$set(_vm.pageData, "largeBankNo", $$v)
                  },
                  expression: "pageData.largeBankNo"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5902f69e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5902f69e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/bank/bank-info-base.vue
// module id = cGt/
// module chunks = 1